"use client";
import { Link } from "@/i18n/navigation";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SectionHeader from "./SectionHeader";

export default function GuideCards({ items = [], title }) {
  return (
    <div
      aria-label={title || "Bilgi kartları"}
      className="container mx-auto w-full space-y-4 py-6 sm:space-y-6 lg:py-15"
    >
      {title && <SectionHeader title={title} />}

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6">
        {items.map((it, idx) => (
          <GuideCard key={it.href ?? idx} {...it} />
        ))}
      </div>
    </div>
  );
}

function GuideCard({ title, subtitle, href = "#", icon }) {
  return (
    <Link
      href={href}
      title={title}
      className="group flex items-center justify-between rounded-xl border border-gray-200/80 bg-white px-4 py-[21px] transition hover:border-gray-300 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 sm:px-6 sm:py-6"
    >
      <div className="flex items-center gap-3">
        {/* İkon alanı (opsiyonel) */}
        <span aria-hidden className="grid h-10 w-10 place-items-center">
          {icon || (
            /* Basit default ikon - icon prop yoksa göster */
            <svg
              viewBox="0 0 24 24"
              className="h-10 w-10"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 6v6l4 2" />
              <circle cx="12" cy="12" r="9" />
            </svg>
          )}
        </span>

        <div className="min-w-0">
          <p className="text-foreground text-lg font-medium">{title}</p>
        </div>
      </div>

      {/* Sağ ok */}
      <FontAwesomeIcon
        className="h-6 w-6"
        icon={byPrefixAndName.far["chevron-right"]}
      />
    </Link>
  );
}
